import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { __ } from "../../utils";
import { useA11yDispatcher, useCustomizeValues } from "../../hooks";
import { getSidebarCustomize } from "../../sidebar";
import { A11yNotice } from ".";
const A11yTextDecoration = (param)=>{
    let { settings, severity, notAccessible, modifier } = param;
    const customize = getSidebarCustomize();
    const values = useCustomizeValues(settings);
    const hasError = useMemo(()=>{
        const textDecoration = modifier ? modifier(values[settings[0]].value, settings.slice(1).reduce((p, c)=>{
            p.push(values[c].value);
            return p;
        }, []), (setting)=>customize(setting).get()) : values[settings[0]].value;
        return notAccessible.indexOf(textDecoration) > -1 ? textDecoration : false;
    }, [
        JSON.stringify(values),
        notAccessible
    ]);
    useA11yDispatcher({
        setting: settings[0],
        valid: hasError === false
    });
    if (!hasError) {
        return null;
    }
    return /*#__PURE__*/ _jsx(A11yNotice, {
        severity: severity,
        text: __('We recommend that you at least underline links to distinguish normal text from links in order to comply with the {{aPerc}}"perceptibility" of the WCAG 2.2 standard{{/aPerc}} and thereby meet the {{aEuMinimum}}EU\'s minimum legal requirements for accessibility{{/aEuMinimum}}.')
    });
};
export { A11yTextDecoration };
